/** Pure formatting helpers used by the kit (unit-tested in models.test.ts). */

/** Clamp value/max to a 0–100 percentage; non-finite or max <= 0 → 0. */
export function progressPercent(value: number, max: number): number {
  if (!Number.isFinite(value) || !Number.isFinite(max) || max <= 0) return 0;
  return Math.min(100, Math.max(0, (value / max) * 100));
}

/** Shorten long ids around an ellipsis: "1234…7890". Short values are returned as-is. */
export function middleTruncate(value: string, head = 4, tail = 4): string {
  if (value.length <= head + tail + 1) return value;
  return `${value.slice(0, head)}…${value.slice(-tail)}`;
}

/** "1 mapping" / "40 mappings". */
export function pluralize(count: number, noun: { one: string; other: string } | string): string {
  const forms = typeof noun === "string" ? { one: noun, other: `${noun}s` } : noun;
  return `${count.toLocaleString("en-US")} ${count === 1 ? forms.one : forms.other}`;
}
